import React from 'react'
import { formatOffset } from '@/utils/StringUtilities'
import { InputGroup } from 'reactstrap'

class EditableComponent extends React.Component {
  formatOffset (offsetString) {
    return formatOffset(offsetString)
  }
  isEdited () { return true }
  renderControl () {} // to be overriden
  renderReadOnlyText (value) {
    return (<input
      className='form-control'
      type='text'
      disabled
      value={value} />)
  }
  render () {
    return (
      <InputGroup>
        {this.renderControl()}
      </InputGroup>
    )
  }
}

export default EditableComponent



// WEBPACK FOOTER //
// ./src/components/Editors/EditableComponent.js